import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { isAdminType, StateService } from '@services/state.service';
import { unsub } from '@util/utils';
import { ICellRendererParams } from 'ag-grid-community';
import { Subscription } from 'rxjs';
import { TeamDeleteDialogComponent } from '../team-delete-dialog/team-delete-dialog.component';
import { TeamService } from '../team.service';
import { subClosed } from '@util/angular.utils';

@Component({
  selector: 'app-team-delete-button',
  template: `
  <div class="edit-cell-renderer">
    <div class="edit-button-wrapper" *ngIf="team.id">
      <button mat-icon-button class="edit-button2" (click)="clicked()">
        <mat-icon class="edit-icon">edit</mat-icon>
      </button>
    </div>
    <div *ngIf="isAdmin" class="delete-button-wrapper">
      <button mat-icon-button class="delete-button2" (click)="clickDelete()">
        <mat-icon class="delete-icon">delete</mat-icon>
      </button>
    </div>
  </div>
`
})
export class TeamDeleteButtonComponent implements OnInit {

  team: any;

  isAdmin: isAdminType = false;

  stateSub?: Subscription;

  @Input() set data(data: any) {
    if (data && data.id) {
      this.team = data;
    }
  }

  @Output() done = new EventEmitter<boolean>();

  constructor(
    private stateService: StateService,
    private router: Router,
    private teamService: TeamService,
    private matDialog: MatDialog
  ) {
  }
  ngOnInit(): void {
    this.isAdmin = this.stateService.isAdmin();
    this.stateSub = this.stateService.adminChange().subscribe((change: isAdminType) => {
      this.isAdmin = change;
    });
  }

  ngOnDestroy(): void {
    this.stateSub = unsub(this.stateSub);
  }

  agInit(params: ICellRendererParams): void {
    this.team = params.data;
  }

  refresh(params: ICellRendererParams) {
  }

  clicked() {
    this.router.navigate(['/teams/' + this.team.id]);
  }

  clickDelete(): void {
    if (!this.team) {
      return;
    }

    const sub: any = {
      sub: null
    };

    sub.sub = subClosed(this.matDialog.open(TeamDeleteDialogComponent, {
      data: {
        teamId: this.team.id,
        teamName: this.team.name
      }
    }), (res: any) => {
      sub.sub = unsub(sub.sub);
      (res && res.id) && this.teamService.signalTeamDeleted(this.team);
    });
  }
}
